import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import {withAlert} from 'react-alert';
import {getRequest} from "../routes/Routes";
import Expand from 'react-expand-animated';
import '../assets/css/Home.css';
import {getUser} from "../auth/Auth";
import Loading from "../components/Loading";

class ManageOrders extends Component {
    constructor(props) {
        super(props);
        this.state = {orders: [], user: null, loading: true};
    }

    componentDidMount() {
        getUser(this.props.history).then(data => {
            this.setState({user: data});
            this.loadOrders();
        });
    }

    render() {
        if (this.state.user) {
            return (
                this.state.loading ?
                    <Loading/>
                    : <div className="container category-list partner-list">
                        <h1 className="heading">Orders Received</h1>
                        <hr/>
                        {this.getOrderBody()}
                    </div>
            );
        } else {
            return null;
        }
    }

    getOrderBody = () => {
        let orderBody = [];
        this.state.orders.forEach((order, index) => {
            orderBody.push(
                <div key={index}>
                    <div className="d-flex bd-highlight w-100 order order-container"
                         onClick={() => this.expandOrder(index)}>
                        {this.state.user.role_id === 3 ?
                            <div className="p-2 flex-fill bd-highlight">
                                <h4>{order.user.first_name + ' ' + order.user.last_name}</h4>
                            </div>
                            : null
                        }
                        <div className="p-2 flex-fill bd-highlight">
                            <div>Order No: <strong>{order.reference}</strong>
                            </div>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <div>Items: <strong>{this.getOrderProductBody(order.order_products).length - 1} {this.getOrderProductBody(order.order_products).length - 1 > 1 ? 'items' : 'item'}</strong>
                            </div>
                        </div>
                        {this.state.user.role_id === 3 ? [
                                <div className="p-2 flex-fill bd-highlight" key="subTotal">
                                    <div>Sub Total: <strong>Rs.{order.sub_total}</strong></div>
                                </div>,
                                <div className="p-2 flex-fill bd-highlight" key="serviceCharge">
                                    <div>Service Charge: <strong>Rs.{order.service_charge}</strong></div>
                                </div>
                            ]
                            : null
                        }
                        <div className="p-2 flex-fill bd-highlight">
                            <div>
                                Date: <strong>{new Date(order.created_at).toDateString()}</strong><br/>
                                Time: <strong>{new Date(order.created_at).toLocaleTimeString()}</strong>
                            </div>
                        </div>
                    </div>
                    <Expand open={order.open}>
                        {this.state.user.role_id === 3 ?
                            <div className="order-container">
                                Email: <strong>{order.user.email}</strong><br/>
                                Address: <strong>{order.address + ", " + order.city}</strong><br/>
                                Phone: <strong>{order.phone}</strong><br/>
                                Notes: <strong>{order.notes}</strong><br/>
                            </div>
                            : null
                        }
                        <table className="account-details order-detail-container">
                            <thead>
                            <tr>
                                {this.state.user.role_id === 3 ?
                                    <th>Store Name</th>
                                    : null
                                }
                                <th>Product Name</th>
                                <th>Price</th>
                                <th>Quantity</th>
                                <th>Commission</th>
                                <th>Total Receivable</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.getOrderProductBody(order.order_products)}
                            </tbody>
                        </table>
                    </Expand>
                </div>
            )
        });
        return orderBody;
    };

    getOrderProductBody = (orderProducts) => {
        let productBody = [],
            totalReceivable = 0.00,
            commissionTotal = 0.00;
        orderProducts.forEach((orderProduct, index) => {
            if (this.state.user.role_id !== 3 && orderProduct.product.partner_id !== this.state.user.partner.id) {
                return;
            }
            totalReceivable += (orderProduct.price * orderProduct.quantity) - ((orderProduct.price * orderProduct.quantity) * (orderProduct.commission / 100));
            commissionTotal += (orderProduct.price * orderProduct.quantity) * (orderProduct.commission / 100);
            productBody.push(
                <tr key={index}>
                    {this.state.user.role_id === 3 ?
                        <td>{orderProduct.product.partner.name}</td>
                        : null
                    }
                    <td>{orderProduct.product.name}</td>
                    <td>Rs.{orderProduct.price}</td>
                    <td>{orderProduct.quantity}</td>
                    <td>Rs.{(orderProduct.price * orderProduct.quantity) * (orderProduct.commission / 100)}</td>
                    <td>Rs.{(orderProduct.price * orderProduct.quantity) - ((orderProduct.price * orderProduct.quantity) * (orderProduct.commission / 100))}</td>
                </tr>
            )
        });
        productBody.push(
            <tr key="totalRow">
                <td/>
                <td/>
                <td/>
                <td className="font-weight-bold">Total</td>
                {this.state.user.role_id === 3 ?
                    <td className="font-weight-bold">Rs.{commissionTotal}</td>
                    : null
                }
                <td className="font-weight-bold">Rs.{totalReceivable}</td>
            </tr>
        )
        return productBody;
    }

    loadOrders = () => {
        let {orders, user} = this.state;
        getRequest(user.role_id === 3 ? '/api/orders' : '/api/partners/orders', this.state.user.api_token).then(response => {
            if (response.status === 200) {
                if (response.data.error) {
                    this.props.alert.error(response.data.message);
                } else {
                    response.data.orders.forEach((order) => {
                        order.open = false;
                        orders.push(order);
                    });
                    this.setState({orders: orders, loading: false});
                }
            } else {
                this.props.alert.error(response.data.message);
            }
        });
    };

    expandOrder = (index) => {
        let {orders} = this.state;
        orders[index].open = !orders[index].open;
        this.setState({orders: orders});
    };
}

export default withAlert()(withRouter(ManageOrders));
